import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// Get UTM parameters from URL
const getUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get('utm_source') || localStorage.getItem('utm_source') || null,
    utm_medium: params.get('utm_medium') || localStorage.getItem('utm_medium') || null,
    utm_campaign: params.get('utm_campaign') || localStorage.getItem('utm_campaign') || null
  };
};

// Store UTM params in localStorage for session persistence
const storeUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  ['utm_source', 'utm_medium', 'utm_campaign'].forEach(key => {
    const value = params.get(key);
    if (value) localStorage.setItem(key, value);
  });
};

// Initialize - call on app load
export const initAnalytics = () => {
  storeUTMParams();
};

// Track page view
export const trackPageView = async (pageName, path) => {
  try {
    const utmParams = getUTMParams();
    const language = localStorage.getItem('qykfin-language') || 'en';
    
    await axios.post(`${API}/api/analytics/pageview`, {
      page: pageName,
      path: path || window.location.pathname,
      referrer: document.referrer || null,
      utm_source: utmParams.utm_source,
      utm_medium: utmParams.utm_medium,
      utm_campaign: utmParams.utm_campaign,
      user_agent: navigator.userAgent,
      language: language
    });
  } catch (error) {
    // Silently fail - analytics shouldn't break the app
    console.debug('Analytics pageview error:', error);
  }
};

// Track button/element click
export const trackClick = async (elementId, elementText = '', pageName = '') => {
  try {
    const utmParams = getUTMParams();
    
    await axios.post(`${API}/api/analytics/click`, {
      element_id: elementId,
      element_text: elementText,
      page: pageName || document.title,
      path: window.location.pathname,
      utm_source: utmParams.utm_source
    });
  } catch (error) {
    console.debug('Analytics click error:', error);
  }
};

// Higher-order function to wrap click handlers with tracking
export const withClickTracking = (elementId, elementText, handler) => {
  return async (...args) => {
    await trackClick(elementId, elementText);
    if (handler) handler(...args);
  };
};

// React hook for tracking page views
export const usePageTracking = (pageName) => {
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  
  // Use effect would be imported from React in the component using this
  // This is just a helper that returns the tracking function
  return () => {
    trackPageView(pageName, path);
  };
};

export default {
  initAnalytics,
  trackPageView,
  trackClick,
  withClickTracking,
  usePageTracking
};
